export const SAVE_ORDER: "SAVE_ORDER_NUMBER" = "SAVE_ORDER_NUMBER";
export const RESET_ORDER: "RESET_ORDER_NUMBER" = "RESET_ORDER_NUMBER";
export const TOGGLE_ORDER_POSTING: "TOGGLE_ORDER_POSTING" =
  "TOGGLE_ORDER_POSTING";
